import React from 'react';
import styles from '../../styles.css';
import clearStyles from './styles.css';

export default function ShowClearButtons({ buttons, showNestedLists }) {
	return (
		<div className="app-menu-showclear measure-showclear">
			{buttons.map((button, index) => {
				if (button.visible?.() === false) {
					return null;
				}
				const isClear = button.class === 'clear-comparison';
				const isShow = button.class === 'show-comparison';
				return (
					<a
						key={`${button.label.split(' ').join('')}_${index}`}
						onClick={(e) => {
							e.preventDefault();
							button.onClick(showNestedLists);
						}}
						href="#"
						className={`${styles.menuControlButton} ${isClear ? clearStyles.clearButton : ''} ${isShow ? clearStyles.showButton : ''}`}
					>
						{button.label}
						{isClear && (
							<svg className={clearStyles.clearIcon} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
							</svg>
						)}
					</a>
				);
			})}
		</div>
	);
}
